// Lógica de dominio pura para escaneos OCR (bandeja de documentos).
// Extraída de la página para que el shell de navegación (Layout/Sidebar)
// pueda contar pendientes sin arrastrar el chunk lazy de BandejaDocumentos.

// Un escaneo está "pendiente" (en la bandeja) si terminó el OCR de forma
// utilizable y AÚN no materializó su registro. Las cuatro columnas de salida
// cuentan: sin payslip_id/document_id, una nómina o un documento ya archivado
// seguían apareciendo como pendientes para siempre.
export function isPendingScan(s) {
  return !!s
    && !s.expense_id
    && !s.invoice_id
    && !s.payslip_id
    && !s.document_id
    && (s.status === 'completed' || s.status === 'review_needed');
}

// Agrupa por destino detectado. El `else` final es un fail-safe deliberado:
// cualquier destino futuro cae en "sin clasificar" en vez de desaparecer de la
// Bandeja.
export function groupByDestination(scans) {
  const groups = { invoice: [], expense: [], payroll: [], archive: [], unclassified: [] };
  for (const s of scans) {
    if (s.detected_destination === 'invoice') groups.invoice.push(s);
    else if (s.detected_destination === 'expense') groups.expense.push(s);
    else if (s.detected_destination === 'payroll') groups.payroll.push(s);
    else if (s.detected_destination === 'archive') groups.archive.push(s);
    else groups.unclassified.push(s);
  }
  return groups;
}
